export const fontFamily = 'Inter, sans-serif';
